import { render, staticRenderFns } from "./TagsRow.vue?vue&type=template&id=4ead8039&scoped=true&"
import script from "./TagsRow.vue?vue&type=script&lang=js&"
export * from "./TagsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead8039",
  null
  
)

export default component.exports